'use client';

import _defineProperty from "/codebuild/output/src1629/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src1629/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src1629/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "styles", "unstyled", "vars", "dropdownOpened", "defaultDropdownOpened", "onDropdownClose", "onDropdownOpen", "onFocus", "onBlur", "onClick", "onChange", "data", "value", "defaultValue", "selectFirstOptionOnChange", "onOptionSubmit", "comboboxProps", "readOnly", "disabled", "filter", "limit", "withScrollArea", "maxDropdownHeight", "size", "searchable", "rightSection", "checkIconPosition", "withCheckIcon", "nothingFoundMessage", "name", "form", "searchValue", "defaultSearchValue", "onSearchChange", "allowDeselect", "error", "rightSectionPointerEvents", "id", "clearable", "clearButtonProps", "hiddenInputProps", "renderOption", "onClear", "autoComplete", "scrollAreaProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useMemo, useEffect } from 'react';
import { useId, useUncontrolled, usePrevious } from '@mantine/hooks';
import 'clsx';
import { useResolvedStylesApi } from '../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { getParsedComboboxData } from '../Combobox/get-parsed-combobox-data/get-parsed-combobox-data.mjs';
import { getOptionsLockup } from '../Combobox/get-options-lockup/get-options-lockup.mjs';
import '../Combobox/ComboboxChevron/ComboboxChevron.mjs';
import { Combobox } from '../Combobox/Combobox.mjs';
import '../Combobox/ComboboxDropdown/ComboboxDropdown.mjs';
import '../Combobox/ComboboxOptions/ComboboxOptions.mjs';
import '../Combobox/ComboboxOption/ComboboxOption.mjs';
import '../Combobox/ComboboxTarget/ComboboxTarget.mjs';
import '../Combobox/ComboboxSearch/ComboboxSearch.mjs';
import '../Combobox/ComboboxEmpty/ComboboxEmpty.mjs';
import '../Combobox/ComboboxFooter/ComboboxFooter.mjs';
import '../Combobox/ComboboxHeader/ComboboxHeader.mjs';
import '../Combobox/ComboboxEventsTarget/ComboboxEventsTarget.mjs';
import '../Combobox/ComboboxDropdownTarget/ComboboxDropdownTarget.mjs';
import '../Combobox/ComboboxGroup/ComboboxGroup.mjs';
import '../Combobox/ComboboxClearButton/ComboboxClearButton.mjs';
import '../Combobox/ComboboxHiddenInput/ComboboxHiddenInput.mjs';
import { OptionsDropdown } from '../Combobox/OptionsDropdown/OptionsDropdown.mjs';
import { useCombobox } from '../Combobox/use-combobox/use-combobox.mjs';
import '../Combobox/Combobox.context.mjs';
import { InputBase } from '../InputBase/InputBase.mjs';
var defaultProps = {
  searchable: false,
  withCheckIcon: true,
  allowDeselect: true,
  checkIconPosition: "left"
};
var Select = factory(function (_props, ref) {
  var props = useProps("Select", defaultProps, _props);
  var classNames = props.classNames,
    styles = props.styles,
    unstyled = props.unstyled,
    vars = props.vars,
    dropdownOpened = props.dropdownOpened,
    defaultDropdownOpened = props.defaultDropdownOpened,
    _onDropdownClose = props.onDropdownClose,
    _onDropdownOpen = props.onDropdownOpen,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    _onClick = props.onClick,
    onChange = props.onChange,
    data = props.data,
    value = props.value,
    defaultValue = props.defaultValue,
    selectFirstOptionOnChange = props.selectFirstOptionOnChange,
    _onOptionSubmit = props.onOptionSubmit,
    comboboxProps = props.comboboxProps,
    readOnly = props.readOnly,
    disabled = props.disabled,
    filter = props.filter,
    limit = props.limit,
    withScrollArea = props.withScrollArea,
    maxDropdownHeight = props.maxDropdownHeight,
    size = props.size,
    searchable = props.searchable,
    rightSection = props.rightSection,
    checkIconPosition = props.checkIconPosition,
    withCheckIcon = props.withCheckIcon,
    nothingFoundMessage = props.nothingFoundMessage,
    name = props.name,
    form = props.form,
    searchValue = props.searchValue,
    defaultSearchValue = props.defaultSearchValue,
    onSearchChange = props.onSearchChange,
    allowDeselect = props.allowDeselect,
    error = props.error,
    rightSectionPointerEvents = props.rightSectionPointerEvents,
    id = props.id,
    clearable = props.clearable,
    clearButtonProps = props.clearButtonProps,
    hiddenInputProps = props.hiddenInputProps,
    renderOption = props.renderOption,
    _onClear = props.onClear,
    autoComplete = props.autoComplete,
    scrollAreaProps = props.scrollAreaProps,
    others = _objectWithoutProperties(props, _excluded);
  var parsedData = useMemo(function () {
    return getParsedComboboxData(data);
  }, [data]);
  var optionsLockup = useMemo(function () {
    return getOptionsLockup(parsedData);
  }, [parsedData]);
  var _id = useId(id);
  var _useUncontrolled = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: null,
      onChange: onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 3),
    _value = _useUncontrolled2[0],
    setValue = _useUncontrolled2[1],
    controlled = _useUncontrolled2[2];
  var selectedOption = typeof _value === "string" ? optionsLockup[_value] : void 0;
  var previousSelectedOption = usePrevious(selectedOption);
  var _useUncontrolled3 = useUncontrolled({
      value: searchValue,
      defaultValue: defaultSearchValue,
      finalValue: selectedOption ? selectedOption.label : "",
      onChange: onSearchChange
    }),
    _useUncontrolled4 = _slicedToArray(_useUncontrolled3, 2),
    search = _useUncontrolled4[0],
    setSearch = _useUncontrolled4[1];
  var combobox = useCombobox({
    opened: dropdownOpened,
    defaultOpened: defaultDropdownOpened,
    onDropdownOpen: function onDropdownOpen() {
      _onDropdownOpen === null || _onDropdownOpen === void 0 || _onDropdownOpen();
      combobox.updateSelectedOptionIndex("active", {
        scrollIntoView: true
      });
    },
    onDropdownClose: function onDropdownClose() {
      _onDropdownClose === null || _onDropdownClose === void 0 || _onDropdownClose();
      combobox.resetSelectedOption();
    }
  });
  var _useResolvedStylesApi = useResolvedStylesApi({
      props: props,
      styles: styles,
      classNames: classNames
    }),
    resolvedClassNames = _useResolvedStylesApi.resolvedClassNames,
    resolvedStyles = _useResolvedStylesApi.resolvedStyles;
  useEffect(function () {
    if (selectFirstOptionOnChange) {
      combobox.selectFirstOption();
    }
  }, [selectFirstOptionOnChange, _value]);
  useEffect(function () {
    if (value === null) {
      setSearch("");
    }
    if (typeof value === "string" && selectedOption && ((previousSelectedOption === null || previousSelectedOption === void 0 ? void 0 : previousSelectedOption.value) !== selectedOption.value || (previousSelectedOption === null || previousSelectedOption === void 0 ? void 0 : previousSelectedOption.label) !== selectedOption.label)) {
      setSearch(selectedOption.label);
    }
  }, [value, selectedOption]);
  var clearButton = clearable && !!_value && !disabled && !readOnly && /* @__PURE__ */jsx(Combobox.ClearButton, _objectSpread(_objectSpread({
    size: size
  }, clearButtonProps), {}, {
    onClear: function onClear() {
      setValue(null, null);
      setSearch("");
      _onClear === null || _onClear === void 0 || _onClear();
    }
  }));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsxs(Combobox, _objectSpread(_objectSpread({
      store: combobox,
      __staticSelector: "Select",
      classNames: resolvedClassNames,
      styles: resolvedStyles,
      unstyled: unstyled,
      readOnly: readOnly,
      onOptionSubmit: function onOptionSubmit(val) {
        _onOptionSubmit === null || _onOptionSubmit === void 0 || _onOptionSubmit(val);
        var optionLockup = allowDeselect ? optionsLockup[val].value === _value ? null : optionsLockup[val] : optionsLockup[val];
        var nextValue = optionLockup ? optionLockup.value : null;
        nextValue !== _value && setValue(nextValue, optionLockup);
        !controlled && setSearch(typeof nextValue === "string" ? (optionLockup === null || optionLockup === void 0 ? void 0 : optionLockup.label) || "" : "");
        combobox.closeDropdown();
      },
      size: size
    }, comboboxProps), {}, {
      children: [/* @__PURE__ */jsx(Combobox.Target, {
        targetType: searchable ? "input" : "button",
        autoComplete: autoComplete,
        children: /* @__PURE__ */jsx(InputBase, _objectSpread(_objectSpread({
          id: _id,
          ref: ref,
          rightSection: rightSection || clearButton || /* @__PURE__ */jsx(Combobox.Chevron, {
            size: size,
            error: error,
            unstyled: unstyled
          }),
          rightSectionPointerEvents: rightSectionPointerEvents || (clearButton ? "all" : "none")
        }, others), {}, {
          size: size,
          __staticSelector: "Select",
          disabled: disabled,
          readOnly: readOnly || !searchable,
          value: search,
          onChange: function onChange(event) {
            setSearch(event.currentTarget.value);
            combobox.openDropdown();
            selectFirstOptionOnChange && combobox.selectFirstOption();
          },
          onFocus: function onFocus(event) {
            searchable && combobox.openDropdown();
            _onFocus === null || _onFocus === void 0 || _onFocus(event);
          },
          onBlur: function onBlur(event) {
            var _optionsLockup$_value;
            searchable && combobox.closeDropdown();
            setSearch(_value != null ? ((_optionsLockup$_value = optionsLockup[_value]) === null || _optionsLockup$_value === void 0 ? void 0 : _optionsLockup$_value.label) || "" : "");
            _onBlur === null || _onBlur === void 0 || _onBlur(event);
          },
          onClick: function onClick(event) {
            searchable ? combobox.openDropdown() : combobox.toggleDropdown();
            _onClick === null || _onClick === void 0 || _onClick(event);
          },
          classNames: resolvedClassNames,
          styles: resolvedStyles,
          unstyled: unstyled,
          pointer: !searchable,
          error: error
        }))
      }), /* @__PURE__ */jsx(OptionsDropdown, {
        data: parsedData,
        hidden: readOnly || disabled,
        filter: filter,
        search: search,
        limit: limit,
        hiddenWhenEmpty: !nothingFoundMessage,
        withScrollArea: withScrollArea,
        maxDropdownHeight: maxDropdownHeight,
        filterOptions: searchable && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== search,
        value: _value,
        checkIconPosition: checkIconPosition,
        withCheckIcon: withCheckIcon,
        nothingFoundMessage: nothingFoundMessage,
        unstyled: unstyled,
        labelId: others.label ? "".concat(_id, "-label") : void 0,
        "aria-label": others.label ? void 0 : others["aria-label"],
        renderOption: renderOption,
        scrollAreaProps: scrollAreaProps
      })]
    })), /* @__PURE__ */jsx(Combobox.HiddenInput, _objectSpread({
      value: _value,
      name: name,
      form: form,
      disabled: disabled
    }, hiddenInputProps))]
  });
});
Select.classes = _objectSpread(_objectSpread({}, InputBase.classes), Combobox.classes);
Select.displayName = "@mantine/core/Select";
export { Select };